import "./TermsOfService.css";

function TermsOfService() {
  return (
    <div className="container terms-of-use">
      <h1 className="text-center">Terms of Service</h1>
      <div className="d-block">
        <div className="d-block">
          <li>
            <span>1.1</span>
            <span>
              By accessing and using this website, you agree to comply with
              these Terms of Use.
            </span>
          </li>
          <li>
            <span>1.2</span>
            <span>
              Products listed are fresh vegetables and herbs supplied by
              Standout Fresh Produce.
            </span>
          </li>
          <li>
            <span>1.3</span>
            <span>Prices are subject to change without notice.</span>
          </li>
          <li>
            <span>1.4</span>
            <span>Orders are confirmed only once payment is received.</span>
          </li>
          <li>
            <span>1.5</span>
            <span>
              We reserve the right to cancel any order due to stock
              unavailability, errors, or unforeseen circumstances, with a full
              refund provided.
            </span>
          </li>
          <li>
            <span>1.6</span>
            <span>
              Users must provide accurate personal and delivery information when
              placing orders.
            </span>
          </li>
          <li>
            <span>1.7</span>
            <span>
              Misuse of this website or fraudulent activity will result in
              account termination and possible legal action.
            </span>
          </li>
        </div>
      </div>
    </div>
  );
}

export default TermsOfService;
